import { useId, type ReactNode } from 'react'

interface Props {
  title: string
  hint?: string
  children: ReactNode
}

export function Section({ title, hint, children }: Props) {
  const id = useId()
  return (
    <section className="od-section" aria-labelledby={id}>
      <h3 className="od-section-title" id={id}>
        {title}
      </h3>
      {hint && <p className="od-hint">{hint}</p>}
      {children}
    </section>
  )
}
